import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify.plugin'
import VeeValidate, { Validator } from 'vee-validate'
import cs from 'vee-validate/dist/locale/cs'

import './styles/main.scss'

Vue.use(VeeValidate, { inject: false })

Validator.localize('cs', cs)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#configuratorApp')
